let _Toast = {
    show: false,
    component: null,
    name: 'toast',
    timer: null,
}

const icon = function (h, name) {
    return (<n-icon icon={name} fill></n-icon>)
}
export default {
    install: function (Vue) {
        Vue.prototype.$toast = function (content, opts) {
            if (_Toast.show) {
                return
            }
            if (!_Toast.component) {
                let ToastComponent = Vue.extend({
                    data() {
                        return {
                            show: true
                        }
                    },
                    render(h) {
                        return h('div',
                            {
                                class: ['toast'],
                                style: { display: this.show ? 'flex' : 'none' }
                            },
                            [
                                icon(h, 'icongouxuan-quan--'),
                                h('span', content)
                            ]
                        )
                    }
                })
                _Toast.component = new ToastComponent()
            }

            clearTimeout(_Toast.timer)
            _Toast.component.show = true
            let element = _Toast.component.$mount().$el;
            document.body.appendChild(element)
            let time = opts && opts.time || 3000
            _Toast.timer = setTimeout(() => {
                _Toast.component.show = _Toast.show = false
            }, time)
        }

    }
}